// import type { FC } from 'react';
import './quiz-input-show-description.css';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { Tooltip } from 'antd';

// type InputDescriptionProps = {
//   description?: object;
//   descriptionColor?: string;
// };

const InputDescription = ({ description, descriptionColor, questionTooltip }) => {
  const getOptions = () => {
    return {
      renderNode: {
        [BLOCKS.UL_LIST]: (node, children) => {
          return <ul className="my-app-list">{children}</ul>;
        },
        [INLINES.HYPERLINK]: ({ data }, children) => {
          return (
            <a href={data.uri} target="_blank" className="my-ap-link">
              {children}
            </a>
          );
        },
      },
    };
  };

  //SHOWING DESCRIPTION
  function ShowInputDescription(description) {
    return (
      <Tooltip title={questionTooltip} color={"#003E69"}>
        <div className="description-container" style={{ color: `${descriptionColor}` }}>
          {documentToReactComponents(description, getOptions())}
        </div>
      </Tooltip>
    );
  }

  return <>{description && ShowInputDescription(description)}</>;
};

export default InputDescription;
